import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { timeoutInSeconds: Number }

  connect () {
    const timeoutInSeconds = this.timeoutInSecondsValue || 5

    setTimeout(() => {
      this.element.remove()
    }, timeoutInSeconds * 1000)
  }
}
